module.exports = __webpack_public_path__ + "img/galeria-pets-4.63d0d72e.jpg";